/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tracks where the user came from (platform and acquisition source). Fields are flexible strings with recommended values documented.
 * @export
 * @interface UserOrigin
 */
export interface UserOrigin {
    /**
     * System/platform where account was created
     * @type {string}
     * @memberof UserOrigin
     */
    platform?: UserOriginPlatformEnum;
    /**
     * Original user ID from source platform (e.g., DIG user_id, Discord snowflake)
     * @type {string}
     * @memberof UserOrigin
     */
    platformId?: string;
    /**
     * How user found us / acquisition channel
     * @type {string}
     * @memberof UserOrigin
     */
    acquisition?: UserOriginAcquisitionEnum;
    /**
     * Reference ID for acquisition (referral code, challenge ID, campaign ID)
     * @type {string}
     * @memberof UserOrigin
     */
    acquisitionRef?: string;
    /**
     * Marketing campaign name (UTM or internal)
     * @type {string}
     * @memberof UserOrigin
     */
    campaign?: string;
    /**
     * Unix timestamp (ms) when user was imported (for migrated users)
     * @type {number}
     * @memberof UserOrigin
     */
    importedAt?: number;
}


/**
 * @export
 */
export const UserOriginPlatformEnum = {
    WEB: 'WEB',
    DISCORD: 'DISCORD',
    OVERWOLF: 'OVERWOLF',
    MOBILE: 'MOBILE',
    DIG_IMPORT: 'DIG_IMPORT',
    BLITZ_IMPORT: 'BLITZ_IMPORT',
    PARTNER: 'PARTNER',
    REALM: 'REALM'
} as const;
export type UserOriginPlatformEnum = typeof UserOriginPlatformEnum[keyof typeof UserOriginPlatformEnum];

/**
 * @export
 */
export const UserOriginAcquisitionEnum = {
    ORGANIC: 'ORGANIC',
    REFERRAL: 'REFERRAL',
    CHALLENGE: 'CHALLENGE',
    CAMPAIGN: 'CAMPAIGN',
    SOCIAL: 'SOCIAL',
    PARTNER: 'PARTNER',
    QUEST: 'QUEST'
} as const;
export type UserOriginAcquisitionEnum = typeof UserOriginAcquisitionEnum[keyof typeof UserOriginAcquisitionEnum];


/**
 * Check if a given object implements the UserOrigin interface.
 */
export function instanceOfUserOrigin(value: object): value is UserOrigin {
    return true;
}

export function UserOriginFromJSON(json: any): UserOrigin {
    return UserOriginFromJSONTyped(json, false);
}

export function UserOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'] == null ? undefined : json['platform'],
        'platformId': json['platformId'] == null ? undefined : json['platformId'],
        'acquisition': json['acquisition'] == null ? undefined : json['acquisition'],
        'acquisitionRef': json['acquisitionRef'] == null ? undefined : json['acquisitionRef'],
        'campaign': json['campaign'] == null ? undefined : json['campaign'],
        'importedAt': json['importedAt'] == null ? undefined : json['importedAt'],
    };
}

export function UserOriginToJSON(json: any): UserOrigin {
    return UserOriginToJSONTyped(json, false);
}

export function UserOriginToJSONTyped(value?: UserOrigin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'platformId': value['platformId'],
        'acquisition': value['acquisition'],
        'acquisitionRef': value['acquisitionRef'],
        'campaign': value['campaign'],
        'importedAt': value['importedAt'],
    };
}

